/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * The signed-in user RECORD behind `state.auth.currentUser`, which holds two
 * shapes: the bare user right after login (`setTokenAndUser` keeps
 * `payload.user` in state) and the stored `{ user, token }` payload after any
 * reload (localStorage gets the whole payload, and a "Switch user" session
 * stores `{ user }` and always reloads). `currentUser.id` is therefore
 * undefined on every reloaded page — the Assign drawer's "your peers" row
 * never showed while viewing as a counsellor (owner, 2026-10-28). Read the
 * person through this.
 */
export function currentUserRecord(currentUser: any): any | null {
  if (!currentUser || typeof currentUser !== "object") return null;
  const inner = currentUser.user;
  return inner && typeof inner === "object" ? inner : currentUser;
}

/** The signed-in user's id, or null when nobody is signed in. */
export function currentUserIdOf(currentUser: any): number | null {
  const id = Number(currentUserRecord(currentUser)?.id);
  return Number.isFinite(id) && id > 0 ? id : null;
}

type AuthSlice = { auth: { currentUser: any } };

export const selectCurrentUserRecord = (state: AuthSlice) =>
  currentUserRecord(state.auth?.currentUser);

export const selectCurrentUserId = (state: AuthSlice) =>
  currentUserIdOf(state.auth?.currentUser);
